import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * LOK-1122 — defensive cleanup for a known Radix bug where a Dialog/Popover
 * that closes mid-animation can leave `pointer-events: none` set on
 * `document.body`, making every subsequent click a no-op until the next page
 * paint. We sweep the leak on every route change and on a short interval.
 *
 * No-op when the style is already clear, so it's effectively free.
 */
export function RadixPointerEventsGuard() {
  const location = useLocation();

  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (document.body.style.pointerEvents === 'none') {
      document.body.style.pointerEvents = '';
    }
  }, [location.pathname]);

  return null;
}
